document.addEventListener('DOMContentLoaded', function () {
  // jQuery ve Flickity yoksa sessizce çık
  if (typeof window.jQuery === 'undefined' || typeof window.Flickity === 'undefined') {
    return;
  }

  var $ = window.jQuery;
  var PRODUCTS_PER_PAGE = 0;

  function initializeFlickity(slider) {
    var isMobile = window.matchMedia("(max-width: 768px)").matches;

    var flickityInstance = new Flickity(slider, {
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      autoPlay: false,
      prevNextButtons: !isMobile,
      draggable: true
    });

    $(slider)
      .data('flickity', flickityInstance)
      .addClass("flickity-enabled");

    setTimeout(function () {
      $(slider).find(".product_all_images").css("visibility", "visible");
    }, 200);
  }

  function reinitializeFlickity() {
    $(".cus_flickity_slider").each(function () {
      if ($(this).hasClass("flickity-enabled")) {
        var flickityInstance = $(this).data('flickity');
        if (flickityInstance) {
          flickityInstance.destroy();
        }
        $(this).removeClass("flickity-enabled");
      }
      initializeFlickity(this);
    });
  }

  // Sayfa ilk yüklendiğinde mevcut slider’ları başlat
  $(".cus_flickity_slider").each(function () {
    initializeFlickity(this);
  });

  // Sayfadaki ilk ürün sayısını al (load more için)
  PRODUCTS_PER_PAGE = $(".product-card").length || 1;

  // ---- Load More butonu
  $("body").off("click", "#load-more-button").on("click", "#load-more-button", function (event) {
    event.preventDefault();

    $(".load_more_span").hide();
    $(".loading_span").show();

    function afterLoad() {
      // Yeni ürünleri işaretle
      $(".product-card").not(".initialized").addClass("newly-added");

      $(".newly-added .cus_flickity_slider").each(function () {
        if (!$(this).hasClass("cus_scroll_slider")) {
          $(this).addClass("cus_scroll_slider");
        }
      });

      setTimeout(function () {
        $(".cus_scroll_slider").each(function () {
          if (!$(this).hasClass("flickity-enabled")) {
            $(".cus_flickity_slider .cus_pro_list:not(:first-child)").css({
              visibility: "visible",
              opacity: "1"
            });
            initializeFlickity(this);
          }
        });

        $(".newly-added").removeClass("newly-added").addClass("initialized");
        $(".cus_scroll_slider").removeClass("cus_scroll_slider");

        $(".load_more_span").show();
        $(".loading_span").hide();

        var totalPages = parseInt($(".cus_total_pages_count").val(), 10) || 1;
        var totalProducts = $(".product-card").length;
        var currentPage = Math.ceil(totalProducts / PRODUCTS_PER_PAGE);

        if (currentPage >= totalPages) {
          $("#load-more-button").hide();
        }
      }, 100);
    }

    if (!window.infiniteCollection) {
      window.infiniteCollection = new MeetAjaxForProduct({
        container: '.product-list',
        pagination: '.meet_infinite_next',
        method: 'click',
        callback: afterLoad
      });

      setTimeout(function () {
        window.infiniteCollection.meetStopProductMultipleClicks({
          preventDefault: function () {}
        });
      }, 200);
    } else {
      window.infiniteCollection.meetStopProductMultipleClicks({
        preventDefault: function () {}
      });
    }
  });

  // ---- Filtre / sort / fiyat / sayfalama değişince Flickity yeniden kurulsun
  function scheduleReinit(delay) {
    setTimeout(reinitializeFlickity, delay || 300);
  }

  $("body").on("click", "#facets-drawer .checkbox-control label", function () {
    scheduleReinit(600);
  });

  $("body").on("input change", '#filter\\.v\\.price\\.gte, #filter\\.v\\.price\\.lte', function () {
    scheduleReinit(600);
  });

  $("body").on("click", "#sort-by-popover button.popover__value-option", function () {
    scheduleReinit(600);
  });

  $("body").on("click", ".removable-facet facet-link", function () {
    scheduleReinit(600);
  });

  $("body").on("click", ".pagination facet-link a", function () {
    scheduleReinit(600);
  });

  $("body").on("click", "collection-layout-switch.collection-toolbar__layout-switch-list button", function () {
    scheduleReinit(200);
  });

  // ---- Renk swatch tıklamalarında ilk görsele dön
  var swatchObserver = new MutationObserver(function () {
    $(".swatch-image").each(function () {
      $(this).off("click").on("click", function () {
        var dots = $(this)
          .closest(".product-card")
          .find(".flickity-page-dots .dot");
        if (dots.length) {
          dots.first().click();
        }
      });
    });
  });

  swatchObserver.observe(document.body, { childList: true, subtree: true });
});
